import React, { useState, useEffect, useCallback, useRef } from 'react';
import './modal.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PearsonLogo from '../../../images/pearson_logo.png';
import iconFolder from '../../../images/icon_folder.gif';
import fileIcon from '../../../images/icon_file.gif';

import '../../common/css/pw_push5.css';
import { getSubDirectories, downloadBulkFilesInZip, resetBulkUploadStateManageMent } from '../../Dashboard/actions';
import Loader from "../../common/Loader";
import { updateGenricSuccessMessageToEmpty } from '../../User/actions';
import '../../common/css/downloadprogressbar.css';
import apiService from '../../utils/apiService';
import { getCurrentPathFromLocation } from '../../utils/pathUtils';

const BulkDownloadPopup = (props) => {
  const [filesLists, setFilesList] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const [disableCheckbox, setDisableCheckbox] = useState(true);
  const [loading, setLoading] = useState(false);
  const [deleteFilesArray, setDeleteFilesArray] = useState([]);
  const [downloadLoaderVisible, setDownloadLoaderVisible] = useState(false);
  const [modalHeight, setModalHeight] = useState('85%'); // State for modal height  
  const [progressbarVisible, setProgressbarVisible] = useState(false);
  const progressRef = useRef(null); // Reference to progress bar
  const latestProgress = useRef(0); // Store latest progress value
  const progressTextRef = useRef(null);

  const currentPath = getCurrentPathFromLocation(location.pathname);

  const directoriesList = useSelector(state => state.directoriesReducer.serverResponse);
  const downloadFileLimitMsg = useSelector(state => state.UserReducer.userSuccessMessage);
  const closeBulkDownloadPopup = useSelector(state => state.directoriesReducer.closeDownloadPopup);

  useEffect(() => {
    if (Object.entries(downloadFileLimitMsg).length > 0) {
      setDownloadLoaderVisible(false);
      props.onModalPopupStateChange(props.displayModal);
    }
    dispatch(resetBulkUploadStateManageMent({}));
  }, [downloadFileLimitMsg]);

  useEffect(() => {
    if (closeBulkDownloadPopup?.status_code == 200) {
      props.onModalPopupStateChange(props.displayModal);
    }
    dispatch(resetBulkUploadStateManageMent({}));
  }, [closeBulkDownloadPopup]);

  useEffect(() => {
    dispatch(updateGenricSuccessMessageToEmpty({}));
    setFilesList(directoriesList?.data);
    deSelectAllFiles();
    setLoading(false);
  }, [directoriesList]);

  useEffect(() => {
    setLoading(true);
    dispatch(getSubDirectories({ dir: currentPath }));
    if (currentPath !== '/') {
      setDisableCheckbox(false);
    } else {
      setDisableCheckbox(true);
    }
  }, [currentPath, dispatch]);

  const deleteFiles = (e) => {
    if (e.target.checked) {
      setDeleteFilesArray([...deleteFilesArray, e.target.value]);
    } else {
      setDeleteFilesArray(deleteFilesArray.filter(file => file !== e.target.value));
    }
  };

  const selectAllFiles = () => {
    let checkboxArray = document.getElementsByName("fileDownload[]");
    let fileArray = [];
    checkboxArray.forEach((file) => { file.checked = true; fileArray.push(file.value) });
    setDeleteFilesArray([...deleteFilesArray, ...fileArray]);
  };

  const deSelectAllFiles = () => {
    let checkboxArray = document.getElementsByName("fileDownload[]");
    checkboxArray.forEach((file) => { setDeleteFilesArray([]); file.checked = false; });
  };

  const closeModal = (e) => {
    e.stopPropagation();
    props.onModalPopupStateChange(props.displayModal);
  };
  
  const handleDownloadSelected = async () => {
    const pathsToDownload = deleteFilesArray.map((item) => currentPath + '/' + item);
    const encodedPaths = pathsToDownload.map((path) => encodeURIComponent(path));
    const { v4: uuidv4 } = require('uuid');
    if (pathsToDownload.length) {
      setDownloadLoaderVisible(true);
      const Id = uuidv4();
      console.log("web Start Time:", new Date().toISOString());
     // connectWebSocket(Id);
      //await delay(4000);
      
      setModalHeight('85%');

      //newapproach-start
      const downloadId = Id;

      const payload = {
        encodedPaths: {
            encodedPaths,
            dir: encodeURIComponent(currentPath),
            downloadId: downloadId
        }
    };  
    
  try 
  {
    const result = await apiService.post("getFileSize", payload)
      if (result.data.success) {
        // Proceed to start progress simulation or download
        simulateProgress(result.data.downloadId, result.data.totalSize, result.data.interval, (id, progressValue) => {
          // Update your UI
          setProgressbarVisible(true);
           // Store the latest progress value
           latestProgress.current = progressValue;

           if (progressRef.current) {
               progressRef.current.style.width = `${latestProgress.current}%`;
           }  
           if (progressTextRef.current && latestProgress.current >= 98) {
             progressTextRef.current.innerText = "Please wait a moment. Download is about to complete. Zipping is in progress.";
             progressTextRef.current.style.color = "red";
           }
          console.log(` API Progress for ${id}: ${progressValue}%`);
      });
      } else {
        console.log("API Failed to get download metadata:", result.message);
      }
    } catch (error) {      
      console.log("Error on download progressbar", error);
  }

      //newapproach-end
     
      dispatch(downloadBulkFilesInZip({ encodedPaths: { encodedPaths, dir: encodeURIComponent(currentPath) ,downloadId: Id} }));
    } else {
      alert('Please select files that you need to download');
    }
  };

  
  const simulateProgress = (downloadId, totalSize, interval, onUpdateProgress) => {
    let processedSize = 0;
    let prevProgress = 0;
    let progress = 1;
    const multiplier = 0.003;
    const divisor = 3;
    
    const progressInterval = setInterval(() => {
        if (processedSize < totalSize) {
            processedSize += (totalSize / divisor) * multiplier;
            progress = Math.min(Math.round((processedSize / totalSize) * 100), 99);
            progress = Math.max(progress, 1);

            if (progress !== prevProgress) {
                prevProgress = progress;

                // Call the callback to update UI or trigger something
                onUpdateProgress(downloadId, progress);
            }
        } else {
            clearInterval(progressInterval);
            // Optionally finalize at 100%
            onUpdateProgress(downloadId, 100);
        }
    }, interval);
};

  return (
    <>
      <div className="modal" onClick={closeModal}>
        <div className="modal-content-download" style={{ height: modalHeight }} onClick={e => e.stopPropagation()}>
          <table role="presentation" border="0" width="100%" cellSpacing="3" cellPadding="0" className='modal-content-table'>
            <tbody>
              <tr align="left" valign="top">
                <td align="left" valign="middle"><span className="pagetitle">&nbsp;Download Files</span></td>
                <td align="right" valign="middle"><img src={PearsonLogo} title="Pearson Education" alt="Pearson Education" width="85" height="21" hspace="0" vspace="0" border="0" /></td>
                <td><span className="close" onClick={closeModal}>&times;</span></td>
              </tr>
            </tbody>
          </table>

          <div className='generalcoursecontainer'>
            <div className="table-container-bulkdownload">
              <table className='myTable' border="1" width="99%" cellSpacing="1" cellPadding="4">
                <thead>
                  <tr align="left" valign="top">
                    <th align="center" valign="middle" width="60" scope="col">Download</th>
                    <th align="left" valign="middle" scope="col"> &nbsp;Name</th>
                    <th align="left" valign="middle" width="100" scope="col">&nbsp;Size (Bytes)</th>
                    <th align="left" valign="middle" width="120" scope="col">&nbsp;Last Modified</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr align="left" valign="top">
                      <td colSpan="4" className="cellWhite">
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    filesLists && filesLists.length > 0 && (
                      filesLists.map((fileList, index) => {
                        let cellStyle = "cellGreen";
                        if (index % 2 === 0) {
                          cellStyle = "cellWhite";
                        }
                        let folderIcon = iconFolder;
                        if (fileList['isFile']) {
                          folderIcon = fileIcon;
                        }
                        return (<tr align="left" valign="top" key={index}>
                          <td width="70" className={"checkboxalign " + cellStyle}>
                            <input type="checkbox" name="fileDownload[]" value={fileList['directory']} disabled={disableCheckbox} onClick={deleteFiles} />
                          </td>
                          <td className={cellStyle} nowrap="">
                            <div className="folderpointer">
                              &nbsp;<img alt={''} src={folderIcon} />&nbsp;{fileList['directory']}
                            </div>
                          </td>
                          <td className={cellStyle}>{fileList['size']}</td>
                          <td className={"checkboxalign " + cellStyle}>{fileList['last_modified_date']}</td>
                        </tr>)
                      })))}
                </tbody>
              </table>
            </div>

            {(!disableCheckbox && localStorage.getItem('user.role') !== 'Vendor') &&
              <table role="presentation" width="100%">
                <tbody>
                  <tr align="left" valign="top">
                    <td align="left"><button className="cellWhite formButtonGo delete-selected" onClick={selectAllFiles}>Select&nbsp;All</button>
                      <span className="cellWhite">&nbsp;|&nbsp;</span>
                      <button className="cellWhite formButtonGo delete-selected" onClick={deSelectAllFiles}>Clear&nbsp;All</button></td>
                  </tr>
                  <tr align="left" valign="top">
                    <td><button className="formButtonDownload" onClick={handleDownloadSelected}>Download Selected</button></td>
                  </tr>
                  {downloadLoaderVisible && (
                    <tr align="left" valign="top">
                      <td style={{ color: 'green' }}>
                        Please wait for a couple of seconds. Your selected files are downloading. If the download is not happening, please allow browser pop-ups for the site.
                        <div className='loader-container'>
                            {latestProgress.current !== 100 ? <Loader /> : ""}
                            </div>
                      </td>
                    </tr>
                  )}
                  {progressbarVisible && (
                    <tr align="left" valign="top">
                      <td>
                        <div className="download-progress-container">
                          <div className="download-progress-header">                          
                                <div ref={progressTextRef}>
                                  Download is in Progress, Please don't close the window
                                </div>
                          </div>                       

                            <div className="download-progress-bar-wrapper">                              
                                <div className="download-progress-bar">
                                  <div
                                      ref={progressRef}
                                      className="progress"
                                      style={{ width: "1%", height: "100%"}}
                                  ></div>
                                </div>
                              </div>                          
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkDownloadPopup;